import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { site } from "@/config/site";
import { WhatsAppButton, CallButton } from "./CtaButtons";

export const CtaBlock = ({ title = "Hemen", accent = "Randevu", tail = "Alın", text = "Bursa Nilüfer'deki salonumuza bir mesaj kadar yakınsınız. WhatsApp'tan yazın ya da arayın; uygun saati birlikte belirleyelim.", showAppointmentLink = true }) => (
  <section className="relative overflow-hidden py-16 md:py-20 bg-night text-white" aria-labelledby="cta-title" data-testid="cta-block">
    <div className="absolute inset-0 pattern-dots opacity-[0.05]" aria-hidden="true" />
    <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-gold/10 blur-3xl" aria-hidden="true" />
    <div className="relative container-wide text-center">
      <CalendarCheck className="w-10 h-10 mx-auto text-gold mb-4" aria-hidden="true" />
      <h2 id="cta-title" className="text-3xl md:text-5xl font-bold mb-3">{title} <span className="gold-text">{accent}</span> {tail}</h2>
      <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-2">{text}</p>
      <p className="text-sm text-gold/90 mb-8">{site.priceNote}</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <CallButton label={site.phoneShort} testId="cta-block-call" />
        <WhatsAppButton testId="cta-block-whatsapp" />
        {showAppointmentLink && (
          <Link to="/iletisim" className="btn btn-ghost-light" data-testid="cta-block-appointment-link">Randevu Al</Link>
        )}
      </div>
    </div>
  </section>
);
